var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NuxtLink',{staticClass:"link inline-flex relative overflow-hidden",attrs:{"to":_vm.to,"target":_vm.target}},[_c('span',{staticClass:"relative overflow-hidden"},[_c('span',{staticClass:"span"},[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),_c('span',{staticClass:"span"},[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }